import { TPagination } from 'src/@types';
import { IFilter, IPatientDiary } from 'src/@types/apiResponse';
import { IPatient, IPrescriptionCode } from 'src/models';
import { PrescriptionCodeFormData } from 'src/screens/patient-management/components/PrescriptionCodeForm';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

/** 처방코드 발급 */
export const setPrescriptionCode = async (formData: PrescriptionCodeFormData) => {
  try {
    const url = `/prescriptionCode/id`;

    const response = await instance.post<TApiResponseData<IPrescriptionCode>>(url, formData);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 환자 목록 조회 */
export const getPatients = async (pagination: TPagination, filterCondition: IFilter) => {
  try {
    let url = `/user/patients?page=${pagination.page}&size=${pagination.size}`;
    if (filterCondition.filter) {
      url += `&${filterCondition.filter}=${filterCondition.keyword}`;
    }

    const response = await instance.get<TApiResponseData<IPatient[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 날짜별 환자 금연/갈망일지 조회 */
export const getPatientDiary = async (patientId: number, date: string) => {
  try {
    const url = `/smokingDiary/withCraving/${patientId}/${date}`;

    const response = await instance.get<TApiResponseData<IPatientDiary>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 환자 차트 조회 */
export const getPatientChart = async (patientId: number, week: number) => {
  try {
    const url = `/user/patient/chart/${patientId}/${week}`;

    const response = await instance.get<TApiResponseData<any>>(url);

    // SPEC: AI 서버 응답이 v2.0 으로 변경됨 — data.summaryReport = { tendencies: string[], counselor_analysis: string | null }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const summary = response.data.data.summaryReport;
    if (summary && Array.isArray(summary.tendencies)) {
      summary.tendencies = summary.tendencies.filter((item: string) => !item.includes('None'));
    }

    return response.data;
  } catch (error) {
    console.error(error);
  }
};
